import React from 'react';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';
import { LoginSkinnable } from './LoginSkinnable';
import { COMPONENT_TYPES } from '../../../constants';
import { LoginProps } from './Login.types';

/**
 * 로그인 컴포넌트
 * 스킨 시스템을 사용하여 사용자 로그인 기능을 제공하는 컴포넌트
 */
const LoginComponent: React.FC<LoginProps> = (props) => {
  // ComponentData 구성
  const componentData = {
    id: props.id || `${COMPONENT_TYPES.LOGIN}-${Date.now()}`,
    type: COMPONENT_TYPES.LOGIN,
    componentProps: props.componentProps || {},
    props: props,
    style: props.style || {},
    className: props.className || '',
    theme: props.theme || {},
    externalSkin: props.externalSkin
  };
  
  // 렌더 모드 결정
  const mode = props.isEditor ? 'editor' : 
               props.isPreview ? 'preview' : 'production';
  
  // 에디터 props (필요한 경우)
  const editorProps = props.isEditor ? {
    isSelected: props.isSelected,
    onSelect: props.onSelect,
    onEdit: props.onEdit,
    onDelete: props.onDelete
  } : undefined;
  
  return (
    <ComponentSkinWrapper
      component={LoginSkinnable}
      componentData={componentData}
      mode={mode}
      editorProps={editorProps}
    />
  );
};

export default LoginComponent;